export default __webpack_public_path__ + "e489c7a2264399d6151bd3ce28085f89.svg";